import packageInfo from '../../package.json';

export const environment = {
  production: false,
  apiUrl: '/api/',
  appVersion: `QA: v${packageInfo.version}`
};
